"use client"

import { useState } from "react"
import { motion } from "framer-motion"
import { X, Settings, Tag, Folder } from "lucide-react"
import { Button } from "../../../components/ui/button"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../components/ui/tabs"
import SKUConfigModal from "../SKUs/SKUConfigModal"

export default function ConfigurationModal({ clientId, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.2 }}
        className="bg-white dark:bg-slate-900 rounded shadow-lg w-full max-w-4xl flex flex-col max-h-[90vh]"
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-200 dark:border-slate-700">
          <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100 flex items-center">
            <Settings className="h-6 w-6 mr-2 text-orange-500" />
            Configuración de Inventario
          </h2>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
        
        {/* Content */}
        <div className="p-6 flex-1 overflow-y-auto">
          <Tabs defaultValue="skus">
            <TabsList className="mb-6">
              <TabsTrigger value="skus" className="data-[state=active]:bg-orange-500 data-[state=active]:text-white">
                <Tag className="h-4 w-4 mr-2" />
                Configuración SKU
              </TabsTrigger>
              <TabsTrigger value="categories" className="data-[state=active]:bg-orange-500 data-[state=active]:text-white">
                <Folder className="h-4 w-4 mr-2" />
                Gestión de Categorías
              </TabsTrigger>
            </TabsList>
            
            <TabsContent value="skus">
              <div className="p-4 bg-slate-50 dark:bg-slate-800/50 rounded mb-4">
                <h3 className="text-lg font-medium text-slate-800 dark:text-slate-200 mb-2">
                  Configura tu Formato SKU
                </h3>
                <p className="text-slate-600 dark:text-slate-400">
                  Personaliza cómo se generan los SKUs (Unidades de Mantenimiento de Stock) para tus elementos de inventario.
                  Puedes definir prefijos, separadores y formatos de secuencia.
                </p>
              </div>
              
              <SKUConfigModal 
                clientId={clientId} 
                onClose={() => {}} 
                embedded={true} 
              />
            </TabsContent>
            
            <TabsContent value="categories">
              <div className="p-4 bg-slate-50 dark:bg-slate-800/50 rounded mb-4">
                <h3 className="text-lg font-medium text-slate-800 dark:text-slate-200 mb-2">
                  Gestionar Categorías y Subcategorías
                </h3>
                <p className="text-slate-600 dark:text-slate-400">
                  Crea, edita y elimina categorías y subcategorías para organizar tu inventario.
                  Estas categorías estarán disponibles al crear o editar elementos de inventario.
                </p>
              </div>
            </TabsContent>
          </Tabs>
        </div>
        
        {/* Footer */}
        <div className="p-6 border-t border-slate-200 dark:border-slate-700 flex justify-end">
          <Button 
            variant="outline" 
            onClick={onClose}
          >
            Cerrar
          </Button>
        </div>
      </motion.div>
    </div>
  )
} 